import styled from "@emotion/styled";
import { COLORS } from "../../header/header.styled";

/* Title: Inter, 600, 15px */
export const Title = styled.h3`
    margin: 0;
    padding: 0;
    font-family:
        Inter,
        system-ui,
        -apple-system,
        Segoe UI,
        Roboto,
        "Helvetica Neue",
        Arial,
        "Noto Sans";
    font-weight: 600;
    font-size: 15px;
    color: ${COLORS.textPrimary};
`;

export const Block = styled.div`
    margin-top: 0;
    display: flex;
    flex-direction: column;
    gap: 16px;
    width: 100%;
`;

/**
 * Mini card per channel (matches given specs)
 * width: 311; height: 44; min-height: 44px; gap: 12px; angle: 0deg; opacity: 1;
 * border-radius: 12px; border-width: 1px; padding: 12px;
 */

export const ChannelCard = styled.div`
    height: 44px;
    min-height: 44px;
    padding: 12px;
    display: flex;
    align-items: center;
    gap: 12px;
    background: ${COLORS.card};
    border: 1px solid ${COLORS.border};
    border-radius: 12px;
    opacity: 1;
    cursor: pointer;
    -webkit-tap-highlight-color: transparent;

    @media (hover: hover) {
        &:hover {
            background: ${COLORS.cardElevated ?? COLORS.neutralOverlay};
        }
    }

    &:active {
        background: ${COLORS.cardElevated ?? COLORS.neutralOverlay};
    }
`;

/* Keep label & meta compact inside the mini card */
export const ChannelLabel = styled.label`
    font-size: 14px;
    line-height: 1;
    color: ${COLORS.textPrimary};
    -webkit-user-select: none;
    user-select: none;
    cursor: pointer;
`;

export const ChannelMeta = styled.span`
    margin-left: auto;
    display: inline-flex;
    align-items: center;
    gap: 12px;
    font-size: 12px;
    color: ${COLORS.textMuted};
    font-family: "Inter";
    font-style: italic;
`;

export const ChannelCheckbox = styled.input`
    width: 16px;
    height: 16px;
    accent-color: ${COLORS.accent};
    cursor: pointer;
`;

/* Consent panel remains a full-width content block beneath SMS card */
export const ConsentBox = styled.div`
    background: ${COLORS.general};
    border: 1px solid ${COLORS.border};
    border-radius: 10px;
    padding: 12px 16px;
    display: flex;
    flex-direction: column;
    gap: 16px;
`;

export const ConsentText = styled.p`
    margin: 0;
    color: ${COLORS.textSecondary};
    font-size: 13px;
    line-height: 1.4;
    font-family:
        Inter,
        system-ui,
        -apple-system,
        Segoe UI,
        Roboto,
        "Helvetica Neue",
        Arial,
        "Noto Sans";
`;

export const InlineLink = styled.a`
    color: ${COLORS.link};
    text-decoration: none;
    &:hover {
        text-decoration: underline;
    }
`;

export const Actions = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
`;

export const ConfirmBtn = styled.button`
    height: 44px;
    background: ${COLORS.btnRest};
    color: ${COLORS.onPrimary};
    border: 1px solid ${COLORS.outline};
    padding: 12px 16px;
    border-radius: 12px;
    font-weight: 600;
    cursor: pointer;
    font-family:
        Inter,
        system-ui,
        -apple-system,
        Segoe UI,
        Roboto,
        "Helvetica Neue",
        Arial,
        "Noto Sans";
    &:hover {
        background: ${COLORS.btnHover};
    }
`;

export const CancelBtn = styled.button`
    background: transparent;
    color: ${COLORS.textSecondary};
    border: 1px solid ${COLORS.border};
    padding: 12px 16px;
    height: 44px;
    border-radius: 12px;
    cursor: pointer;
    font-family:
        Inter,
        system-ui,
        -apple-system,
        Segoe UI,
        Roboto,
        "Helvetica Neue",
        Arial,
        "Noto Sans";
    &:hover {
        background: ${COLORS.neutralOverlay};
    }
`;
